'use client';

import {
  AtivityItemMode,
  NotificationActivityEnrichedRecord,
  NotificationsPortalContext,
} from '@nx-frontend/shared/types';
import { ActivityItem } from './activity-item';

interface ActivityGroupProps {
  title: string;
  items: NotificationActivityEnrichedRecord[];
  assetsPrefixUrl: string;
  activitiesCategory: string;
  gatewayUrl: string;
  sessionId: string;
  userId: number;
  fetchChatActivities?: boolean;
  portalContext?: NotificationsPortalContext;
  mode?: AtivityItemMode;
  routerPush: (url: string) => void;
  openCommentsByThreadId?: (threadId: string, commentId: string) => void;
  onClose: () => void;
  selectMenuItem?: (itemId: string) => void;
  showFileInDashboard?: (globalId: string) => void;
}

export function ActivityItemGroup({
  assetsPrefixUrl,
  title,
  items,
  activitiesCategory,
  gatewayUrl,
  sessionId,
  userId,
  fetchChatActivities,
  portalContext,
  mode = 'webnotes',
  routerPush,
  openCommentsByThreadId,
  onClose,
  selectMenuItem,
  showFileInDashboard,
}: ActivityGroupProps) {
  return (
    <div className="flex w-full flex-col ">
      <div className="flex w-full py-2.5 px-5 items-start bg-neutral-100">
        <div className="w-full text-neutral-500 text-[10px] font-bold uppercase">{title}</div>
      </div>

      {items.map((item: NotificationActivityEnrichedRecord) => (
        <ActivityItem
          key={item.globalId}
          itemToShow={item}
          assetsPrefixUrl={assetsPrefixUrl}
          activitiesCategory={activitiesCategory}
          gatewayUrl={gatewayUrl}
          sessionId={sessionId}
          userId={userId}
          onClose={onClose}
          openCommentsByThreadId={openCommentsByThreadId}
          selectMenuItem={selectMenuItem}
          fetchChatActivities={fetchChatActivities}
          portalContext={portalContext}
          routerPush={routerPush}
          mode={mode}
          showFileInDashboard={showFileInDashboard}
        />
      ))}
    </div>
  );
}
